import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationLockService {
  private readonly _activeCount = signal(0);
  readonly locked = computed(() => this._activeCount() > 0);

  private readonly _blockUnload = (event: BeforeUnloadEvent): void => {
    event.preventDefault();
    event.returnValue = '';
  };

  lock(): void {
    if (this._activeCount() === 0) {
      window.addEventListener('beforeunload', this._blockUnload);
    }
    this._activeCount.update((c) => c + 1);
  }

  unlock(): void {
    this._activeCount.update((c) => Math.max(0, c - 1));
    if (this._activeCount() === 0) {
      window.removeEventListener('beforeunload', this._blockUnload);
    }
  }
}
